import { ReactNode, useEffect, useRef } from "react";

export const ClickOutsideComponent = ({ children, onClose }: { children: ReactNode, onClose: () => void}) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const handleClickOutside = (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          onClose();
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [onClose]);
  
    return <div className="outside-component" style={{ width: '100%' }} ref={wrapperRef}>{children}</div>;
  };import { ReactNode, useEffect, useRef } from "react";

export const ClickOutsideComponent = ({ children, onClose }: { children: ReactNode, onClose: () => void}) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const handleClickOutside = (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          onClose();
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [onClose]);
  
    return <div className="outside-component" style={{ width: '100%' }} ref={wrapperRef}>{children}</div>;
  };